'use client'

import { createContext, SetStateAction, useContext } from 'react';
import type { ApplicationContextType } from './types';
import { APP_CONFIG } from '@/config';

export const useApplication = () => {
  const context = useContext(ApplicationContext);
  if (!context) {
    throw new Error('useApplication must be used inside a ApplicationProvider');
  }
  return context;
};

export const defaultContext = {
  api: {} as ApplicationContextType['api'],
  url: new URL((typeof window !== "undefined" && window.location.toString()) || APP_CONFIG.app.publicUrl),
  isShowOverlay: false,
  isShowChat: false,
  httpReferer: null,
  navCurrentPage: null,
  sidebarOpen: true,
  setNavCurrentPage: () => undefined,
  setSidebarOpen: () => undefined,
  setOverlayRenderElement: () => undefined,
  setChatRenderElement: () => undefined,
  setShowOverlay: (() => undefined) as unknown as SetStateAction<boolean>,
  OverlayElement: () => null,
  ChatElement: () => null,
};
export const ApplicationContext = createContext<ApplicationContextType>(defaultContext);
